import { useState } from "react";

const DEFAULT_HOTSPOTS = {
  "222-222": {
    "222-222-180-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 81.5625,
        y: 56.56250000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-180-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 81.5625,
        y: 56.56250000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-180-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 81.5625,
        y: 56.56250000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-210-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 83.4375,
        y: 57.50000000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-210-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 83.4375,
        y: 57.50000000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-210-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 83.4375,
        y: 57.50000000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-250-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 86.5625,
        y: 58.43750000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-250-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 86.5625,
        y: 58.43750000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
    "222-222-250-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 86.5625,
        y: 58.43750000000001,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 40,
        y: 50.62500000000001,
      },
    ],
  },
  "111-111": {
    "111-111-90-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 62.8125,
        y: 58.4375,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-90-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 62.8125,
        y: 58.4375,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-90-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 62.8125,
        y: 58.4375,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-90-TA2": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 62.8125,
        y: 58.4375,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-100-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 66.25,
        y: 59.0625,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-100-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 66.25,
        y: 59.0625,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-100-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 66.25,
        y: 59.0625,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-100-TA2": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 66.25,
        y: 59.0625,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-110-SVI": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 69.0625,
        y: 59.6875,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-110-VID": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 69.0625,
        y: 59.6875,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-110-TAM": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 69.0625,
        y: 59.6875,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
    "111-111-110-TA2": [
      {
        id: "WIDTH",
        hotspotLabel: 1,
        x: 69.0625,
        y: 59.6875,
      },
      {
        id: "COLOR",
        hotspotLabel: 2,
        x: 38.125,
        y: 55.00000000000001,
      },
    ],
  },
};

const useHotspots = (configurationId) => {
  const [hotspots, setHotspots] = useState({});

  const changeHotspots = (newHotspots) => {
    setHotspots((state) => {
      const newState = { ...state };
      let hasChanged = false;
      const variationsArray = Object.keys(newHotspots);
      variationsArray.map((variation) => {
        if (state[variation] == null) {
          newState[variation] = newHotspots[variation];
          hasChanged = true;
        } else if (Array.isArray(state[variation])) {
          newHotspots[variation]?.map((newHotspot) => {
            const currentHotspotIdx = state[variation].findIndex(
              (stateHotspot) => stateHotspot.id === newHotspot.id,
            );
            if (currentHotspotIdx < 0) {
              newState[variation].push(newHotspot);
              hasChanged = true;
            } else {
              const currentHotspot = state[variation][currentHotspotIdx];
              if (
                currentHotspot.x !== newHotspot.x ||
                currentHotspot.y !== newHotspot.y
              ) {
                newState[variation][currentHotspotIdx] = newHotspot;
                hasChanged = true;
              }
            }
            return false;
          });
          return false;
        }
        return false;
      });
      if (hasChanged) {
        return newState;
      }
      return state;
    });
  };

  const setInitialHotspots = ({ variations, wizardParameters = [] }) => {
    setHotspots((state) => {
      let newState = { ...state };
      let hasChanged = false;

      const buildDesiredHotspots = (variation) => {
        const validParams = (variation?.parameters || []).filter(
          (p) => Object.values(p)[0] != null,
        );
        const paramHotspots = validParams.map((parameter, idx) => ({
          id: Object.keys(parameter)[0].toUpperCase(),
          hotspotLabel: idx + 1,
          x: 50,
          y: 50,
        }));
        const wizardHotspots = wizardParameters.map((wp, idx) => ({
          id: wp.id,
          label: wp.label,
          hotspotLabel: paramHotspots.length + idx + 1,
          x: 50,
          y: 50,
        }));
        return [...paramHotspots, ...wizardHotspots];
      };

      if (DEFAULT_HOTSPOTS[configurationId]) {
        const defaults = DEFAULT_HOTSPOTS[configurationId];
        Object.keys(defaults).forEach((varId) => {
          if (!newState[varId]) {
            newState[varId] = [...defaults[varId]];
            hasChanged = true;
          }
        });
        // Add wizard hotspots to all known variations
        if (wizardParameters.length > 0) {
          Object.keys(newState).forEach((varId) => {
            const existing = newState[varId] || [];
            const existingIds = existing.map((h) => h.id);
            const newWizardHotspots = wizardParameters
              .filter((wp) => !existingIds.includes(wp.id))
              .map((wp, idx) => ({
                id: wp.id,
                label: wp.label,
                hotspotLabel: existing.length + idx + 1,
                x: 50,
                y: 50,
              }));
            if (newWizardHotspots.length > 0) {
              newState[varId] = [...existing, ...newWizardHotspots];
              hasChanged = true;
            }
          });
        }
      } else {
        variations.forEach((variation) => {
          if (!variation?.img) return;
          const desired = buildDesiredHotspots(variation);
          const existing = newState[variation.id];

          if (!existing) {
            // New variation — set all hotspots at default
            newState[variation.id] = desired;
            hasChanged = true;
          } else {
            // Existing variation — only add missing hotspots
            const existingIds = existing.map((h) => h.id);
            const missing = desired.filter((h) => !existingIds.includes(h.id));
            if (missing.length > 0) {
              newState[variation.id] = [...existing, ...missing];
              hasChanged = true;
            }
          }
        });
      }

      return hasChanged ? newState : state;
    });
  };

  const removeHotspotById = (hotspotId) => {
    setHotspots((state) => {
      let hasChanged = false;
      const newState = {};
      Object.keys(state).forEach((varId) => {
        const filtered = state[varId].filter((h) => h.id !== hotspotId);
        if (filtered.length !== state[varId].length) hasChanged = true;
        // Re-number hotspot labels
        newState[varId] = filtered.map((h, idx) => ({
          ...h,
          hotspotLabel: idx + 1,
        }));
      });
      return hasChanged ? newState : state;
    });
  };

  return { hotspots, setInitialHotspots, moveHotspots: changeHotspots, removeHotspotById };
};

export default useHotspots;
